import { DEBUG } from "../assets";
import { config } from "../config";
import { validateConfig } from "../config/validate";
import { debugParams } from "../core/debugParams";
import { k } from "../core/kaplay";
import { loadAssets } from "../core/loader";
import { addTitle, addUiRoot } from "../ui/layout";

export function bootScene() {
    if (DEBUG) validateConfig(config);

    const ui = addUiRoot();
    addTitle(ui, "Loading…", -60, 56);
    ui.add([k.rect(600, 24, { radius: 12 }), k.pos(0, 20), k.anchor("center"), k.color(0, 0, 0), k.opacity(0.4)]);
    const bar = ui.add([k.rect(0, 24, { radius: 12 }), k.pos(-300, 20), k.anchor("left"), k.color(255, 248, 231)]);

    loadAssets((done) => (bar.width = 600 * done)).then(() => {
        k.onLoad(() => k.go(debugParams.scene ?? "menu"));
    });
}
